import React from 'react';
import {EdgeProps} from 'reactflow';

import BaseEdgeRenderer from 'ui-library/reactflow/edges/BaseEdgeRenderer';
import {LineStyle} from 'ui-library/reactflow/edges/edgeOptions';
import {ReactFlowLockedContext} from 'ui-library/reactflow/LockedContext';

import {getEdgeStatus} from './edgeUtils';
import RemoveEdgeLabel from './RemoveEdgeLabel';

export default function TaskSchemaDataFlowEdge(props: EdgeProps): JSX.Element {
  const locked = ReactFlowLockedContext.useContext();

  return (
    <>
      <BaseEdgeRenderer
        {...props}
        data={{
          ...props.data,
          lineStyle: LineStyle.DASHED,
          status: getEdgeStatus(props),
        }}
      />
      {props.selected && !locked && <RemoveEdgeLabel {...props} />}
    </>
  );
}
